export const environment = {
  production: false,

  //urlBase: 'http://191.98.131.180/libreriavirtual-0.0.1/',
  // daet ini
  urlBase: 'https://aplicatalogodigital.editoraperu.com.pe/catalogodigital-0.0.1/',
  //urlBase: 'http://172.20.2.39:8080/catalogodigital/',
  //urlBase: 'http://172.16.28.252:8080/catalogodigital/',
  //urlBase: 'https://10.10.100.70/catalogodigital/',
  // daet fin

  // ===== RECAPTCHA V3 CONFIGURATION =====
  // Habilitar o deshabilitar reCAPTCHA
  recaptchaEnabled: true, // Deshabilitado para pruebas en desarrollo
  // Site key de Google reCAPTCHA v3 (obtener de https://www.google.com/recaptcha/admin)
  recaptchaSiteKey: '6LfjSfkrAAAAALBmexjPdI5nTLzytkSpGJosZyKk',

  urlPayme: '',
  
  apiURLGestionUsuario:'', 
  
  // baseURLRuc:'https://servicios.editoraperu.com.pe/webapi_sunat/api/ConsultaRUC/',
    
  //NIUBIZ
  //urlAcceso:'http://172.20.0.61:82/api/PagoWeb/AccesoPagoWeb',
  

  // PROD
  // baseURLRuc:'https://servicios.editoraperu.com.pe/webapi_sunat/api/ConsultaRUC/',
  urlAcceso:'https://apps.editoraperu.com.pe/niubiz/api/PagoWeb/AccesoPagoWeb',
  urlNiubiz:'https://static-content.vnforapps.com/v2/js/checkout.js',
 
    

  //TEST
  //urlAcceso:'https://qa.editoraperu.com.pe/niubiz/api/PagoWeb/AccesoPagoWeb',
  //urlNiubiz:'https://static-content-qas.vnforapps.com/env/sandbox/js/checkout.js?qa=true',

  // Endpoints centralizados en backend para RENIEC/SUNAT
  consultarDniEndpoint: 'api/portal/external/consultarDNI/',
  consultarRucEndpoint: 'api/portal/external/consultarRUC/',







  usuarioGestionUsuario:'',
  claveGestionUsuario:'',

  inicioNovedades: 'api/portal/start/novelties',
  efemerides: 'api/efemerides',
  //catalogo
  catalogo:'api/portal/start/activos',
  cata_autor:'api/authors',
  cata_categoria:'api/categories',  
  cata_subCategoria:'api/subcategories',
  cata_anoPublicacion:'api/years',
  busquedaGeneral:'api/portal/start/generalsearch',
  // daet ini
  busquedaGeneral2:'api/portal/start/generalsearch2',
  // daet fin
  //detalleLibro
  detalleLibro:'api/portal/detail/activos',
  recomendados:'api/portal/detail/recommended',
  //Maestra
  maestras: 'api/masters',
  // daet1
  ubigeo: 'api/ubigeo',
  //usuario
  login: 'api/portal/auth/login',
  loginAdmin: 'api/admin/auth/login',
  userid: 'api/portal/auth/user',
  direccion: 'api/portal/address/address',
  direccionList: 'api/portal/address/addresses',
  registrarUsuario:'api/portal/auth/signup',
  actualizarUsuario: 'api/portal/auth/user',
  listaPedidos: 'api/portal/order/orders',
  orderPedido : 'api/portal/order/orderDet',
  recuperarContrasea:'api/portal/auth/forgotpassword',
  recuperarPassToken:'api/portal/auth/user',
  //ubigeo
  ubigeoDepart: 'api/departments',
  ubigeoProv: 'api/provinces',
  ubigeoDist: 'api/districts',
  //OrdenPago   
  orderCabecera: 'api/portal/order/orderCab',
  calculateOrder: 'api/portal/order/calculate',
  orderGestion: 'api/portal/order/order',
  orderUser: 'api/portal/order/orders',
  orderImage: 'api/portal/order/orderImage2',
  paymerespuesta: 'api/portal/payment/pasarella/response',
  orderinternacional: 'api/portal/order/orderforeign',  

  obtenerMenu:'api/portal/start/menus',
  //sourvenir
  sourvenirNovedades: 'api/portal/souvenir/novelties/',
  sourvenirDetalle: 'api/portal/detail/souvenir/',
  sourvenirRecomendados: 'api/portal/detail/souvenir/recommended/',
  grupoXSubMenu:'api/portal/souvenir/group/',
  catalogoSourvenir: 'api/portal/souvenir/products/',
  listarTemasSourvenir:'api/portal/souvenir/topic',

  ////ADMINISTRADOR
  orderAdmin:'api/admin/tray/orders',
  orderEstadoContinuos: 'api/admin/tray/states',
  orderEstadoGrabar : 'api/admin/tray/order',
  orderDetalleAdmin : 'api/admin/tray/order/orderDet',
  orderCabeceraAdmin : 'api/admin/tray/order/orderCab',
  orderDetalle : 'api/admin/tray/order',

  //categoria
  listCategoriaAdmin : 'api/admin/library/book/category',
  getCategoriaAdminId : 'api/admin/library/book/category/get',
  insertCategoriaAdmin : 'api/admin/library/book/category',
  updateCategoriaAdmin : 'api/admin/library/book/category',
  //año de pulicacion
  listAnioAdmin : 'api/admin/library/book/year',
  getAnioAdminId : 'api/admin/library/book/year/get',
  insertAnioAdmin : 'api/admin/library/book/year',
  updateAnioAdmin : 'api/admin/library/book/year',
  //autor
  listAutorAdmin : 'api/admin/library/book/author',
  getAutorAdminId : 'api/admin/library/book/author/get',
  insertAutorAdmin : 'api/admin/library/book/author',
  updateAutorAdmin : 'api/admin/library/book/author',
  //book
  listBookAdmin : 'api/admin/library/book/book',
  getBookAdminId : 'api/admin/library/book/book/get',
  insertBookAdmin : 'api/admin/library/book/book',
  updateBookAdmin : 'api/admin/library/book/book',

  //inventario Book
  listInvBookAdmin : 'api/admin/library/book/inventory',
  getInvBookAdminId : 'api/admin/library/book/inventory/get',
  insertInvBookAdmin : 'api/admin/library/book/inventory',
  updateInvBookAdmin : 'api/admin/library/book/inventory',
  
  //grupo
  listGrupoAdmin : 'api/admin/library/product/group',  
  getGrupoAdminId : 'api/admin/library/product/group/get',
  insertGrupoAdmin : 'api/admin/library/product/group',
  updateGrupoAdmin : 'api/admin/library/product/group',
  listGrupoCombo: '/api/groups',
  
  //submenu
  listSubmenuAdmin : 'api/admin/library/product/submenu',
  getSubmenuAdminId : 'api/admin/library/product/submenu/get',
  insertSubmenuAdmin : 'api/admin/library/product/submenu',
  updateSubmenuAdmin : 'api/admin/library/product/submenu',
  listSubmenuCombo : '/api/submenus',
  
  //topic
  listTopicAdmin : 'api/admin/library/product/topic',
  getTopicAdminId : 'api/admin/library/product/topic/get',
  insertTopicAdmin : 'api/admin/library/product/topic',
  updateTopicAdmin : 'api/admin/library/product/topic',
  listTopicCombo: '/api/topics',

  // daet
  promocion : 'api/portal/promotion/sent',
  contacto : 'api/portal/contact/sent',

  //producto sourvenir
  listProductoAdmin : 'api/admin/library/product/product',
  getProductoAdminId : 'api/admin/library/product/product/get',
  insertProductoAdmin : 'api/admin/library/product/product',
  updateProductoAdmin : 'api/admin/library/product/product',
  listProductoControles : 'api/admin/library/product/menuItemsProduct',

  //inventario product
  listInvProdAdmin : '/api/admin/library/product/inventory',
  getInvProdAdminId : 'api/admin/library/product/inventory/get',
  insertInvProdAdmin : 'api/admin/library/product/inventory',
  updateInvProdAdmin : 'api/admin/library/product/inventory',
  getListInvProdAdmin : 'api/admin/library/product/inventory/list/get',
  updateInvProdConceptoAdmin : 'api/admin/library/product/inventory/siga',
  deleteInvProdAdmin : 'api/admin/library/product/inventory/del',
 //modalidad
  listModalidad:'api/modalidades',
  //concepto de pago
  listConceptoPagoAdminLib : '/api/admin/library/external/book/get',
  listConceptoPagoAdminProd : '/api/admin/library/external/product/get',
  verefySigaLibro : '/api/admin/library/external/product/verify',

  //servicios externos
  buscarReniecDni : '/api/admin/library/consultarDNI',
  buscarSunatRuc : '/api/admin/library/consultarRUC',

  //geolocalización
  geoLocationCountry: 'api/portal/geolocation/country',
  geoLocationCountryCode: 'api/portal/geolocation/country/code',

  //estadistica
  registrarVisita: 'api/portal/estadistica/visita',

  // ===== GOOGLE ANALYTICS 4 =====
  ga4MeasurementId: 'G-CPQC2XLQ00'  // Vacío en dev para no trackear
};

